import { createSlice } from '@reduxjs/toolkit'

type authState = {
  jwttoken: boolean
  period: boolean
  available: boolean
  loginType: string | number
  pageToggle: boolean
}

const initialState: authState = {
  jwttoken: false,
  period: false,
  available: false,
  loginType: '',
  pageToggle: false,
}

const authReducer = createSlice({
  name: 'jwttoken',
  initialState: initialState,
  reducers: {
    jwttokenState(state, action) {
      state.jwttoken = action.payload
    },
    periodState(state, action) {
      state.period = action.payload
    },
    availableState(state, action) {
      state.available = action.payload
    },
    loginTypeState(state, action) {
      state.loginType = action.payload
    },
    pageToggleState(state, action) {
      state.pageToggle = action.payload
    },
  },
})

export const {
  jwttokenState,
  periodState,
  availableState,
  loginTypeState,
  pageToggleState,
} = authReducer.actions

export default authReducer.reducer
